<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { XIcon } from 'vue-feather-icons'

import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import { eventBus } from '@/vcs/_shared/eventBus'
import CpExample from '@/assets/images/cp-example.png'
import ModalMixin from '@/mixins/ModalMixin.js'

export default {
  components: { XIcon },
  extends: BaseModal,
  mixins: [ModalMixin],
  data: function () {
    return { CpExample }
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp',
      drId: 'getDrId'
    })
  },
  mounted() {
    eventBus.$emit('refresh-token-via-websockets')
  },
  methods: {
    openBox(size) {
      this.$blockUI()
      let drId = this.drId
      let token = window.localStorage.getItem('delivery_request_token')

      if (this.$dev) {
        this.mockedBehavior(drId)
        return
      }

      let params = {}
      size ? (params = { boxSize: size }) : null

      axios({
        method: 'put',
        url: `/delivery_requests/${drId}/open_box`,
        headers: {
          common: {
            Authorization: `Bearer ${token}`
          }
        },
        params
      })
        .then((response) => {
          let boxId = response.data.boxId
          window.localStorage.setItem('box_id', boxId)
          this.close({ boxId, drId })
        })
        .catch((error) => {
          let errorCode = Object.values(
            (((error || {}).response || {}).data || {}).errors
          )
          if (errorCode == 'dr:9') {
            this.openCloseLockerPromptModal(this.$t('CLOSE_LOCKER_MESSAGE_A'), () => {
              this.openBox(size)
            })
          } else if (errorCode == 'dr:10') {
            this.openNoAvailableBoxesModal()
          } else {
            this.$errorHumanized(error)
          }
        })
        .finally(() => {
          this.$unblockUI()
        })
    },
    getFreeBoxes(size) {
      if (!this.cp) {
        return 0
      }

      let allBoxes = []
      for (const unit of this.cp.units) {
        allBoxes.push(unit.boxes)
      }
      let count = allBoxes.flat().filter((box) => {
        return (
          box.size == size &&
          box.status == 'free' &&
          box.isActive &&
          box.members.length == 0 &&
          !box.isTablet
        )
      }).length

      return count
    },

    mockedBehavior(drId) {
      this.$unblockUI()
      window.localStorage.setItem('box_id', '8ed6e096-17fb-4518-a879-9ea2629934c1')
      this.close({
        drId,
        boxId: '8ed6e096-17fb-4518-a879-9ea2629934c1'
      })
    }
  }
}
</script>

<template lang="pug">
span
  .modal-header
    x-icon(size="1.5x" @click="close(false)")
  .modal-body
    h1.page__header {{ $t('modals.chooseBoxesModal.header') }}
    h3.page__description.mb-5 {{ $t('modals.chooseBoxesModal.subheader') }}

    .row
      .col-5.col-lg-3.offset-lg-3
        button.btn.btn-outline-dark.btn-block.text-center.mb-3(
          type="button"
          :disabled="getFreeBoxes('s') == 0"
          v-ea-click="() => { openBox('s') }"
        )
          span.font-weight-bold.mr-2 S
          span ({{ getFreeBoxes('s') }})

        button.btn.btn-outline-dark.btn-block.text-center.mb-3(
          type="button"
          :disabled="getFreeBoxes('m') == 0"
          v-ea-click="() => { openBox('m') }"
        )
          span.font-weight-bold.mr-2 M
          span ({{ getFreeBoxes('m') }})

        button.btn.btn-outline-dark.btn-block.text-center.mb-3(
          type="button"
          :disabled="getFreeBoxes('l') == 0"
          v-ea-click="() => { openBox('l') }"
        )
          span.font-weight-bold.mr-2 L
          span ({{ getFreeBoxes('l') }})

        button.btn.btn-outline-dark.btn-block.text-center.mb-3(
          type="button"
          :disabled="getFreeBoxes('xl') == 0"
          v-ea-click="() => { openBox('xl') }"
        )
          span.font-weight-bold.mr-2 XL
          span ({{ getFreeBoxes('xl') }})

        button.btn.btn-outline-dark.btn-block.text-center.mb-3(
          type="button"
          :disabled="getFreeBoxes('xxl') == 0"
          v-ea-click="() => { openBox('xxl') }"
        )
          span.font-weight-bold.mr-2 XXL
          span ({{ getFreeBoxes('xxl') }})

      .col-7.col-lg-6
        img.w-100.mb-4(:src="CpExample")
        .text-center.text-muted {{ $t('modals.availableBoxesModal.exampleCollectomate') }}

  .modal-footer.fixed
    .row.h-100
      .col-12.h-100.d-flex.align-items-center.justify-content-between
        button.btn.btn-link.text-danger(type="button" v-ea-click="$killSession") {{ $t('cancelDelivery') }}
        button.btn.btn-primary(type="button" v-ea-click="() => { openBox() }") {{ $t('skip') }}
</template>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
.box-info {
  background: $gray-lightest;
  padding: 1rem;
  border-radius: 1rem;
  margin-bottom: 2rem;
  text-align: center;
}

.modal-body button {
  @media (max-width: 991.98px) {
    padding: 1rem;
    font-size: 1.5rem;
  }
}
</style>
